import { render, staticRenderFns } from "./ArtworkFlagDialog.vue?vue&type=template&id=fe1011e2&"
import script from "./ArtworkFlagDialog.vue?vue&type=script&lang=js&"
export * from "./ArtworkFlagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports